// extracted by mini-css-extract-plugin
export default {"modal":"is","topline":"js","img":"ks","textcontents":"ls","heading":"ms","copy":"ns","link":"os","close":"ps","modalinner":"qs","container":"rs"};
    if(module.hot) {
      // 1711717530796
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  